import {
  Component,
  computed,
  ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { RvButtonComponent } from 'src/app/components/button/button.component';
import { StorageUtilsService } from 'src/app/storage/services/storage-utils.service';
import { BrandLogoService } from '../../services/brand-logo.service';

@Component({
  selector: 'brand-settings',
  templateUrl: './brand-settings.component.html',
  imports: [RvButtonComponent],
  providers: [BrandLogoService],
})
export class BrandSettingsComponent {
  private companyStateService = inject(CompanyStateService);
  private storageUtilsService = inject(StorageUtilsService);
  private brandLogoService = inject(BrandLogoService);

  private logoInput =
    viewChild.required<ElementRef<HTMLInputElement>>('logoInput');
  private logoUploadButton = viewChild.required<
    string,
    ElementRef<HTMLButtonElement>
  >('logoUploadButton', { read: ElementRef });

  readonly companyName: string =
    this.companyStateService.getSelectedCompanyName();

  readonly logo = this.brandLogoService.logo;
  readonly isLogoUploading = this.brandLogoService.isUploading;
  readonly logoUploadFailed = this.brandLogoService.uploadFailed;
  readonly logoAcceptedTypes = this.brandLogoService.acceptedTypes;

  readonly logoFileName = computed(() => {
    const file = this.logo()?.file;

    return file ? this.storageUtilsService.fileNameOf(file) : '';
  });

  uploadLogo(): void {
    this.logoInput().nativeElement.click();
  }

  onLogoFileSelected(): void {
    const input = this.logoInput().nativeElement;

    this.brandLogoService.upload(Array.from(input.files || [])).finally(() => {
      input.value = '';
    });
  }

  selectLogoFromStorage(): void {
    this.brandLogoService.selectFromStorage();
  }

  removeLogo(): void {
    this.brandLogoService.remove();
    this.logoUploadButton().nativeElement.focus();
  }
}
